import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@mantine/core';

import { useEditGoodsItem } from '../api/editGoodsItem';
import { Fields } from '../hooks/useGoodsItemForm';

import { GoodsItemForm } from './GoodsItemForm';

type EditModalProps = {
  goodsItemId: string;
  initialValues: Fields;
};

export const EditModal = NiceModal.create(({ initialValues, goodsItemId }: EditModalProps) => {
  const modal = useModal();

  const { mutate, isLoading } = useEditGoodsItem({
    department: initialValues.department,
    onSuccess: modal.hide,
  });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title="Редактирование товара"
    >
      <GoodsItemForm
        isLoading={isLoading}
        onSubmit={(params) => mutate({ ...params, _id: goodsItemId })}
        initialValues={initialValues}
      />
    </Modal>
  );
});
